import { ChangeDetectionStrategy, Component, EventEmitter, input, model, Output } from '@angular/core';


export type SortDirection = 'asc' | 'desc' | '';
const rotate: { [key: string]: SortDirection } = { 'asc': 'desc', 'desc': '', '': 'asc' };
export interface SortEvent {
	column: string;
	direction: SortDirection;
}


/**
 * Component for table header to sort related column. 
 */
@Component({
	selector: 'sortable-header',
	templateUrl: './sortable-header.component.html',
	host: {
		'(click)': 'rotate()'
	},
	changeDetection: ChangeDetectionStrategy.Eager
})
export class SortableHeaderComponent {

	name = input('');
	direction = model<SortDirection>('');
	@Output() sort = new EventEmitter<SortEvent>();

	/**
	 * Emit column name and sort order when click on header.
	 */
	rotate(): void {
		this.direction.set(rotate[this.direction()]);
		this.sort.emit({ column: this.name(), direction: this.direction() });
	}

	/**
	 * Reset sort order of header.
	 */
	reset(): void {
		this.direction.set('');
	}
}
